// extracted by mini-css-extract-plugin
export var dropdownIcon = "_o5-6";
export var imgContainer = "_o5-3";
export var menuIcon = "_o5-5";
export var pillWrapper = "_o5-2";
export var pillsContainer = "_o5-1";
export var subscriptionCard = "_o5-0";
export var subscriptionLogo = "_o5-4";